export default {
    WorkflowDesign: {
        name: 'Process Name',
        Add: 'Add Process',
        View: 'View',
        Deployment: 'Deploy',
        Process: 'Process Definition ID',
        ID: 'Deployment ID',
        file: 'Process File Name',
        Status: 'Status',
        Version: 'Version',
        Operation: 'Action',
        want: 'Are you sure you want to continue the operation?',
        form: {
            Empty: 'Clear',
            Import: 'Import File',
            Export: 'Export File',
            pictures: 'Export Image',
            Save: 'Save as New Version',
            version: 'You are saving this process as a new version. The new version needs to be deployed again to take effect (the old version will still be executed during the undeployed period). Are you sure you want to continue?',
            please: 'Failed to open the model, please confirm that the model conforms to the Bpmn2.0 specification',
            ps: 'Save Successfully',
            cancel: 'Current page data is not saved, are you sure you want to discard it?',
            cancel1: 'Cancelled',
        }
    }
};
